const Message = ({ notification }) => {
    return (
      <div className="flex flex-col"> 
        <div id="notificationHeader">
          {/* image is optional */}
          {notification?.image && (
            <div id="imageContainer">
              <img src={notification.image} width={100} />
            </div>
          )}
          <span className="text-linkColor">{notification.title}</span>
        </div>
        <div  className="text-black">{notification.body}</div>
      </div>
    );
  };
  
  export default Message;